import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Toast from 'react-bootstrap/Toast';
import Alert from 'react-bootstrap/Alert';



class MessageBannerItem extends React.Component {

	getAlertVariant(message){
		let retVar = 'info'
		switch (message.type) {
		  	case "ERR":
				retVar = 'danger';
			break;
			case "WARN":
				retVar = 'warning';
			break;
		  	case "MSG":
		  	default:
		  		retVar='info';
		}
		return retVar;
	}

	getToastAutohide(message){
		let retVar = 1000; //ms
		switch (message.hide) {
		  	case "Short":
				retVar = 1000;
			break;
		  	case "Medium":
				retVar = 3000;
			break;
			case "Long":
				retVar = 10000;
			break;
			case "Immortal":
				retVar = -1; // :P
			break;
			default:
		  		retVar=1000;
		}
		return retVar;
	}

	render(){
		if (this.props.messages) return (
	<div aria-live="polite" aria-atomic="true" style={{ position: 'relative', zIndex:'500' }} >
		<div style={{ position: 'absolute', top: 80, left: 10,}} >			
			{ 
				// eslint-disable-next-line
				this.props.messages.map((message)=>{
					let dd = new Date();
					if (message.mpk) return (    
						<Toast key={message.mpk} onClose={()=>this.props.onCloseMessage(message.mpk)} autohide={(message.hide === 'Immortal'?false:true)} delay={this.getToastAutohide(message)}>
							<Toast.Header>
								<img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
								<small className="mr-auto">{message.title}</small>&nbsp;
								<small>{('0'+dd.getHours()).slice(-2)}:{('0'+dd.getMinutes()).slice(-2)}</small>
							</Toast.Header>
						<Toast.Body>
							<Alert variant={this.getAlertVariant(message)}>
						    	{message.msg}
							</Alert>
						</Toast.Body>
				    </Toast>
)
				})
			}

    	</div>
    </div>




		);
	}
}

export default MessageBannerItem;